export const DELETE_EMPLOYEE_REQUEST = 'DELETE_EMPLOYEE_REQUEST';

export const deleteEmployeeRequest = ( id ) => ({
    type: DELETE_EMPLOYEE_REQUEST,
    payload: { id }
});
